import React, {useState} from 'react';
import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import CustomerService from "../services/CustomerService";
import HelperMethods from "../../General/services/HelperMethods";
import styles from './DataExportModal.module.scss';

function DataExportModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, setAlert: Function, handleCustomerMenuModalClose: Function }) {

    const [loading, setLoading] = useState<string|undefined>('');
    const delay = (ms:number) => new Promise(res => setTimeout(res, ms));
    const handleDataExport = async () => {
        let filename = '';

        try {
            const generateResponse = await CustomerService.generateDataExport(props.selectedCustomer.clientId, props.selectedCustomer.corpSite);
            const taskId = generateResponse.taskId;
            
            let status;
            do {
                status = await CustomerService.getDataExportStatus(taskId);
                setLoading(status.progress + '%' + (status.secondaryProgress ? ' - ' + status.secondaryProgress : ''));
                await delay(500);
            } while (!status.complete);
            
            if (status.errorMessage) {
                props.setAlert({type: 'error', message: status.errorMessage});
                props.handleClose();
                props.handleCustomerMenuModalClose();
            }
            else {
                filename = status.result.fileDownloadName;
                HelperMethods.createDownloadableItemForClient(status.result.fileContents, filename);
            }
            setLoading(undefined);
        } catch (e) {
            setLoading(undefined);
            props.setAlert({type: 'error', message: 'An error has occured with the data export, please contact HSC Care DevOps'});
            props.handleClose();
            props.handleCustomerMenuModalClose();
        }
    }
    
    const renderModalContent = () => {
        let modalContent;
        
        if (loading) {
            modalContent = (
                <div className={styles.DataExportModalLoaderContainer}>
                    <Spinner>{loading}</Spinner>
                </div>
            )
        } else {
            modalContent = (
                <div className={styles.DataExportModalButtonContainer}>
                    <div className={styles.DataExportModalButtonElement}>
                        <Button
                            text={'Customer Export'}
                            onClick={() => handleDataExport()}
                        />
                    </div>
                </div>
            )
        }

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='blue'
            heading={'Data Export'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DataExportModal;
